import Image from 'next/image';
import React, { FunctionComponent } from 'react';

import MimeType from '../../../../models/mime';

interface IProps {
  fileType: MimeType;
}

function getSrc(fileType: MimeType) {
  switch (fileType) {
    case MimeType.csv:
      return '/img/files/file_csv.svg';
    case MimeType.doc:
      return '/img/files/file_doc.svg';
    case MimeType.docx:
      return '/img/files/file_docx.svg';
    case MimeType.jpeg:
      return '/img/files/file_jpg.svg';
    case MimeType.pdf:
      return '/img/files/file_pdf.svg';
    case MimeType.png:
      return '/img/files/file_png.svg';
    case MimeType.xls:
    case MimeType.xlsx:
      return '/img/files/file_xlsx.svg';
    // TODO: Need a default file type. Folder is placeholder
    default:
      return '/img/files/folder.svg';
  }
}

const FileIcon: FunctionComponent<IProps> = ({ fileType }) => {
  const src = getSrc(fileType);

  if (src) {
    return (
      <div className="relative z-10">
        <Image alt="File icon" height={40} src={src} width={40} />
      </div>
    );
  }

  return null;
};

export default FileIcon;
